import React, { useMemo } from 'react';

import {
  printMissingConfigError,
  SiteConfigManager,
  useApplicationState,
  useUserMessages,
} from '@atlas/core';
import { CLIENT_PROFILE_COMPONENT_TYPES } from '@atlas/routing';
import { MenuItem } from '@atlas/ui';

import { PLATFORM_TYPES } from 'common/constants';
import { defaultRoutes } from 'components/MainRouter/constants';
import history from 'components/MainRouter/history';
import { useMessagesTabConfig } from 'src/hooks/useMessagesTabConfig';

import MenuFooterLinkItem from './MenuFooterLinkItem';

const { MOBILE, MULTIPLATFORM } = PLATFORM_TYPES;

const filterPlatformSpecificNav = nav =>
  nav?.filter(el => el.platform_type === MULTIPLATFORM || el.platform_type === MOBILE);

const { account, settings } = defaultRoutes;

const MenuFooterLinkList = () => {
  const bottomNav = SiteConfigManager.getConfig('navigation.bottom', []);
  const pages = SiteConfigManager.getConfig('config.pages', []);
  const applicationState = useApplicationState();
  const { authenticated } = applicationState;
  const { unreadMessagesCount } = useUserMessages();
  const messagesTab = useMessagesTabConfig();

  const menuMainNav = useMemo(() => {
    let menuMainNav = [];
    const settingsPage = pages.find(page => page.type === CLIENT_PROFILE_COMPONENT_TYPES.SETTINGS);

    if (settingsPage?.isActive) {
      menuMainNav.push({
        icon: 'settings',
        location: settings,
        name: 'Settings',
      });
    }

    if (authenticated) {
      menuMainNav = [
        {
          icon: 'account',
          location: account,
          name: 'my_profile',
          withNotification: !!unreadMessagesCount && messagesTab?.isActive,
        },
        ...menuMainNav,
      ];
    }

    return menuMainNav;
  }, [authenticated, messagesTab?.isActive, pages, unreadMessagesCount]);

  const platformSpecificBottomNav = filterPlatformSpecificNav(bottomNav);

  if (bottomNav.length === 0) {
    printMissingConfigError('navigation.bottom');
  }

  return (
    <>
      <div className="user-profile-group">
        {menuMainNav.map(({ icon, location, name, withNotification }) => (
          <MenuItem
            icon={icon}
            key={name}
            onClick={() => history.push(location)}
            renderArrow
            text={name}
            withNotification={withNotification}
          />
        ))}
      </div>

      <div className="user-profile-group user-profile-group--mb-0">
        {platformSpecificBottomNav?.map(({ children, name }) => {
          if (children.length === 0) {
            return null;
          }

          const platformSpecificChildren = filterPlatformSpecificNav(children);

          return (
            <MenuFooterLinkItem
              key={name}
              name={name}
              platformSpecificChildren={platformSpecificChildren}
            />
          );
        })}
      </div>
    </>
  );
};

export default MenuFooterLinkList;
